// extracted by mini-css-extract-plugin
module.exports = {"root":"IIElB","sticky":"_2pTcF","title":"N4BCz","heading":"_3jhrF","active":"_1WsHh","mainHeading":"_23ttb","iconContainer":"_2Dn9J","bg":"EnUJm","icon":"_3CHrx"};